<script lang="ts">
	//UI
	import { Card, HubProfileBottomLineButton } from "@hitit/new_ui";
	import MemberBadge from "@hitit/hub/src/v7/components/store/MemberBadge.svelte";

	//Utils
	import { link } from "svelte-routing";
	import { t } from "@hitit/hub/src/stores";
	//Types
	import type { AccessControlDTO, AddressData } from "@hitit/api";
	//Props
	export let accessControlList: AccessControlDTO[];
	//Constants
	//Variables
	//Functions
	function parsedAddress(addressDTO: AddressData) {
		const { formattedAddress1, formattedAddress2, detailAddress } = addressDTO;
		const preAddress = formattedAddress1 || formattedAddress2;
		return `${preAddress} ${detailAddress}`;
	}

	function convertStoreLink(storeId: string) {
		return `/store/${storeId}/`;
	}
	//Do

</script>

<Card noPadding>
	<div class="container">
		<p class="title">{$t('mbr.user.own_store')}</p>
		<div class="list">
			{#each accessControlList as dto}
				<div class="access-control">
					<div class="badge">
						<MemberBadge userType={dto.permission} />
					</div>
					<div class="link">
						<HubProfileBottomLineButton
							newTab={false}
							action={link}
							rightIconVisible
							href={convertStoreLink(dto.storeId)}>
							<span>{$t('global.go_direct')}</span>
						</HubProfileBottomLineButton>
					</div>
					<div class="name">{dto.storename || ''}</div>
					<div class="address">{parsedAddress(dto.addressDTO)}</div>
				</div>
			{/each}
			<div class="access-control dummy" />
			<div class="access-control dummy" />
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 20px 10px;
		.title {
			font-weight: 600;
			color: #46474b;
			font-size: 1.25rem;
		}

		.list {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;

			.access-control {
				align-items: center;
				width: 100%;
				box-sizing: border-box;
				padding: 20px 10px;
				background-color: #f0f0f4;
				border-radius: 5px;
				display: flex;
				flex-wrap: wrap;
				gap: 10px;
				&.dummy {
					display: none;
				}
				.badge {
					flex-grow: 1;
				}
				.name {
					width: 100%;
					font-size: 1.25rem;
					color: #46474b;
					font-weight: 500;
				}
				.link {
					span {
						color: #3c68d6;
					}
				}
				.address {
					color: #46474b;
				}
			}
		}
	}
	@include DesktopSize {
		.container {
			padding: 30px;
			gap: 30px;

			.title {
				font-size: 2.1875rem;
			}

			.list {
				flex-direction: row;
				flex-wrap: wrap;
				gap: 20px;
				.access-control {
					padding: 20px;
					width: auto;
					flex-basis: 30%;
					flex-grow: 1;
					min-width: 350px;
					&.dummy {
						display: block;
						padding: 0;
						height: 0;
					}
					.badge {
						order: 1;
						width: 100%;
					}
					.name {
						width: auto;
						order: 2;
						flex-grow: 1;
						font-size: 1.5rem;
					}

					.link {
						order: 3;
					}

					.address {
						order: 4;
						font-size: 1.25rem;
						width: 100%;
					}
				}
			}
		}
	}

</style>
